import { Circle, Play } from 'lucide-react';
import { useEventCallback } from 'usehooks-ts';

import Hourglass from '@/assets/icons/hourglass.svg?react';
import RepeatButton from '@/assets/icons/repeat-button.svg?react';
import ThumbsUp from '@/assets/icons/thumbs-up.svg?react';
import { Button } from '@/shared/components/ui/button';
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogDescription,
  ResponsiveDialogFooter,
  ResponsiveDialogHeader,
  ResponsiveDialogTitle,
} from '@/shared/components/ui/custom/responsive-dialog';

interface PlayNowModalProps {
  openModal: boolean;
  setOpenModal: (open: boolean) => void;
}

export function PlayNowModal({ openModal, setOpenModal }: PlayNowModalProps) {
  const handleCloseModal = useEventCallback(() => {
    setOpenModal(false);
  });
  return (
    <ResponsiveDialog open={openModal} onOpenChange={setOpenModal}>
      <ResponsiveDialogContent className="bg-cold-950 mx-auto flex flex-col">
        <ResponsiveDialogHeader className="flex flex-col items-center gap-1.5 p-4">
          <Play className="text-positive-600 size-14" />
          <ResponsiveDialogTitle>
            You've entered <b className="whitespace-nowrap">Play Now mode</b>
          </ResponsiveDialogTitle>
          <ResponsiveDialogDescription>
            You're now visible to other players who are ready to play right now.
          </ResponsiveDialogDescription>
        </ResponsiveDialogHeader>
        <div className="border-purple-brand-700 bg-purple-brand-950 mx-5 my-4 flex flex-col gap-2 rounded-2xl border-2 px-3 py-4 md:mx-auto md:max-w-md">
          <div className="flex items-center gap-2">
            <Hourglass className="aspect-square size-6 min-w-6" />
            <span className="text-cold-200 text-sm leading-5 font-semibold">
              Will stay turned on until you go inactive for 5 minuts, or until
              you find a duo
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Circle
              className="aspect-square size-6"
              fill="#00D26A"
              stroke="none"
            />
            <span className="text-cold-200 text-sm leading-5 font-semibold">
              Only active players will see you
            </span>
          </div>
          <div className="flex items-center gap-2">
            <RepeatButton className="aspect-square size-6" />
            <span className="text-cold-200 text-sm leading-5 font-semibold">
              You can turn it off anytime
            </span>
          </div>
        </div>
        <ResponsiveDialogFooter className="md:mx-auto md:w-md md:px-0 ">
          <Button variant="default" onClick={handleCloseModal}>
            Got it
            <ThumbsUp />{' '}
          </Button>
        </ResponsiveDialogFooter>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
}
